import React from 'react'
import PropTypes from 'prop-types'

import styles from './radio-button.module.css'
import { classes } from '../util/components'

const RadioButton = props => {
  const {
    name,
    field,
    text,
    value,
    className,
    error,
    touched,
    ...labelProps
  } = props
  return (
    <label
      className={classes(
        styles.radioButton,
        className,
        touched && error && styles.hasError
      )}
      {...labelProps}
    >
      {text}
      <input
        {...field}
        type="radio"
        name={name}
        value={value}
        checked={field.value === value}
        onChange={() => field.onChange(field.name)(value)}
      />
      <span className={styles.checkMark} />
    </label>
  )
}

RadioButton.propTypes = {
  name: PropTypes.string,
  field: PropTypes.object,
  text: PropTypes.string,
  value: PropTypes.string,
  className: PropTypes.string,
}

export default RadioButton
